import React from "react";
import OptionsRow from "../optionsRow/OptionsRow";

const OptionsList = (props) => {
  return (
    <div>
      {props.optionsData.map((item, index) => {
        return (
          <OptionsRow
            {...props}
            key={index}
            index={index}
            optionsData={item}
            released={props.released}
            editChecked={props.editChecked}
            rowEditSaved={props.rowEditSaved}
            numberOfRows={props.numberOfRows}
            rowOptionsEditedCheckbox={props.rowOptionsEditedCheckbox}
            isEditEnabled={props.isEditEnabled}
            newlyReleased={props.newlyReleased}
          />
        );
      })}
    </div>
  );
};

export default OptionsList;
